<!-- <h1 mat-dialog-title>{{type}} Voucher</h1> -->
<div class="dialog-header">
  <h1 mat-dialog-title>{{ type }} Voucher</h1>
  <button mat-icon-button (click)="closeDialog()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <mat-form-field>
    <input matInput [(ngModel)]="voucher" placeholder="Voucher Name" [disabled]="isInputDisabled">
  </mat-form-field>
  <mat-form-field>
    <input matInput [(ngModel)]="description" placeholder="Voucher Description" [disabled]="isInputDisabled">
  </mat-form-field>
  <mat-form-field>
    <input matInput [(ngModel)]="prefix" placeholder="Prefix" [disabled]="isInputDisabled" required #prefixInput="ngModel">
    <mat-error *ngIf="prefixInput.invalid && prefixInput.touched">
      Prefix is required
    </mat-error>
  </mat-form-field>
  <mat-form-field>
    <input matInput [(ngModel)]="cr_no" placeholder="CR count" [disabled]="isInputDisabled">
  </mat-form-field>
  <mat-form-field>
    <input matInput [(ngModel)]="dr_no" placeholder="DR count" [disabled]="isInputDisabled">
  </mat-form-field>
  <mat-form-field>
    <mat-label>Voucher Type</mat-label>
    <mat-select [(ngModel)]="voucher_type" [disabled]="isInputDisabled">
      <mat-option *ngFor="let type of voucherTypes" [value]="type">
        {{ type }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button class="btn btn-success" *ngIf="button" (click)="onSave()"> {{ type }} </button>
  <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
</div>